export default {"src":"/_next/static/media/arrow.7c0c5c07.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};